<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{lang.arecord}}</h2>
      <span @click="searchBox = true"><i class="iconfont icon-record"></i></span>
    </header>
    <div class="main">
      <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" ref="loadmore" :auto-fill="false"
        :topPullText="lang.topPullText" :topDropText="lang.dropText" :topLoadingText="lang.loadingText"
        :bottomPullText="lang.bottomPullText" :bottomDropText="lang.dropText" :bottomLoadingText="lang.loadingText">
        <ul>
          <li class="record-list" v-for="item in recordList" :key="item.id">
            <p><span>{{lang.changM}}：
              <b class="title green " v-if="item.isUp == 0">{{currSymbol}} -{{item.amount}}</b>
              <b class="title red " v-else >{{currSymbol}}{{item.amount}}</b>
            </span></p>
            <p><span>{{lang.changedM}}：<b>{{currSymbol}}{{item.amt_new.toFixed(2)}}</b></span></p>
            <p><span>{{lang.type}}：
              <b v-if="item.type == 1">{{lang.recharge}}</b>
              <b v-else-if="item.type == 2">{{lang.withdraw}}</b>
              <b v-else-if="item.type == 20">{{lang.Buy}}</b>
              <b v-else-if="item.type == 21">{{lang.investEarnings}}</b>
              <b v-else-if="item.type == 22">{{lang.commission}}</b>
            </span></p>
            <p><span>{{lang.time}}：{{item.ctime}}</span></p>
          </li>
        </ul>
      </mt-loadmore>
      <div class="no-data" v-if="recordList.length==0">
        <img src="@img/no-data.png" />
        <p>{{lang.nomore}}</p>
      </div>
    </div>
    <mt-popup v-model="searchBox" position="bottom" class="popup-box">
      <div class="popup-content">
        <div>
          <p>{{lang.stime}}：</p>
          <p>
            <input class="time-input" type="text" v-model="stime" @focus="openpicker(0)">
          </p>
        </div>
        <div>
          <p>{{lang.etime}}：</p>
          <p>
            <input class="time-input" type="text" v-model="etime" @focus="openpicker(1)">
          </p>
        </div>
        <div class="btn" @click="getRecord">{{lang.confirm}}</div>
      </div>
    </mt-popup>
    <mt-datetime-picker ref="picker" type="date" v-model="today" :cancelText="lang.cancel" :confirmText="lang.confirm" @confirm="handleConfirm">
    </mt-datetime-picker>
  </div>
</template>
<script type="text/javascript">
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex'
import router from "../../router";
  export default {
    data() {
      return {
        currSymbol: CONF.CURR_SYMBOL,
        page: 1,
        totalPg: 1,
        recordList: [],
        status:{},
        searchBox:false,
        today: '',
        stime: '',
        etime: '',
      }
    },
    created() {
      this.page = 1;
      this.today = this.getDay(0);
      this.stime = this.getDay(0);
      this.etime = this.getDay(0);
      this.getRecord();
    },
    computed: {
      ...mapState(['userInfo', 'lang'])
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      toDou(n) {
        return n < 10 ? "0" + n : n
      },
      getDay(d) {
        let date = d ? new Date(d) : new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return year + '-' + this.toDou(month) + '-' + this.toDou(day);
      },
      openpicker(n) {
        this.pickernum = n;
        this.$refs.picker.open();
      },
      handleConfirm(value) {
        if (this.pickernum) {
          this.etime = this.getDay(value);
        } else {
          this.stime = this.getDay(value);
        }
      },
      getRecord() {
        this.searchBox  = false;
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/coinlog', {
            page: this.page,
            sdate: this.stime,
            edate: this.etime
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              let data = res.data;
              if (this.page > 1) {
                this.recordList = this.recordList.concat(data.data);
              } else {
                this.recordList = data.data;
              }
              this.totalPg = data.totalNum;
              this.status = data.types;
            } else if (res.data.err == 102||res.data.err == 106) {
              this.$router.push('Login')
              router.push("login")
              sessionStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      loadTop() {
        //下拉刷新
        this.page = 1;
        this.getRecord();
        this.$refs.loadmore.onTopLoaded();
      },
      loadBottom() {
        this.page++;
        if (this.page <= this.totalPg) {
          this.getRecord();
        }
        this.$refs.loadmore.onBottomLoaded();
      },
    }
  }
</script>
<style type="text/css"  scoped>
  .record-list {
    margin: 12px;
    padding: 12px;
    border-radius: 10px;
    background: rgba(139, 152, 244, .1);
  }
  .record-list p {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    color: #666;
  }
  .record-list p b {
    color: #333;
  }

  .record-list p .title {
    color: #000;
    font-size: 15px;
    font-weight: bold;
  }

  .record-list p .red {
    color: rgb(231, 76, 60);
  }

  .record-list p .green {
    color: green;
  }

  .record-list p .yellow {
    color: #ffb115;
  }


  .popup-box {
    width: 100%;
    background: #fff;
    overflow-y: auto;
  }
  .detail-box{
    width:95%;
    margin: auto;
    border-radius: 10px;
    overflow: hidden;
  }
  .detail-box div p:first-child{
      width:120px;
      font-weight: bold;
    }

  .popup-box .popup-content {
    padding: 12px;

  }
  .popup-box .popup-content div {
    display: flex;
    padding: 10px 0;
    align-items: center;
    justify-content: center;
  }
  .popup-box .popup-content div p:first-child {
    width: 100px;
    font-weight: bold;
  }

  .popup-box .popup-content div p:last-child {
    flex: 1;

    input {
      width: 100%;
      height: 40px;
      border-radius: 5px;

      &.time-input {
        border: 1px solid #ddd;
        padding-left: 10px;

        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }

  .popup-box .popup-content div.btn {
    height: 46px;
    line-height: 46px;
    border-radius: 25px;
    margin: 10px 0;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    background: #3476FE;
  }


  .no-data {
    height: 400px;
  }
</style>